import React, { useState } from "react";
import { Add } from "@mui/icons-material";
import {
  Button,
  TextField,
} from "@mui/material";
import { PaymentMethodAction } from "../../../services/payment";
import { Log } from "../../../services/services";
import * as Yup from "yup";
import { useFormik } from "formik";
import { styles } from "../../../utils/styles";
import FormDialog from "../../FormDialog";

function CreateMethodDialog() {
  const [open, setOpen] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const handleClickOpen = () => {
    Log.info('Click button [New Payment Method] - Show popup Add New Payment Method');
    setOpen(true);
  };
  const handleClose = () => {
    resetForm();
    setOpen(false);
  };

  const {
    handleChange,
    handleSubmit,
    handleBlur,
    errors,
    values,
    touched,
    isSubmitting,
    resetForm,
  } = useFormik({
    initialValues: {
      name: "",
    },
    validationSchema: Yup.object().shape({
      name: Yup.string()
        .required("This field is required")
        .test('not-whitespace-only', 'This field is required', function(value) {
          return value && value.trim().length > 0;
        }),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      const name = values.name.trim();
      Log.info('Click button [Add Payment Method] - Add New Payment Method', { name });
      await PaymentMethodAction("ADD", { paymentMethod: name });
      setSubmitting(false);
      handleClose();
      setLoaded(true);
    },
  });

  return (
    <div>
      <Button variant="contained" onClick={handleClickOpen} startIcon={<Add />} sx={{ ...styles.customButton }}>
        New Payment Method
      </Button>
      <FormDialog
        open={open}
        onClose={handleClose}
        title="Add New Payment Method"
        handleSubmit={handleSubmit}
        loading={isSubmitting}
        maxWidth="sm"
      >
        <TextField
          name="name"
          required
          autoFocus
          margin="dense"
          label="Payment Method"
          fullWidth
          variant="standard"
          value={values.name}
          onChange={handleChange}
          onBlur={handleBlur}
          error={Boolean(touched.name && errors.name)}
          helperText={touched.name && errors.name}
          disabled={isSubmitting}
        />
      </FormDialog>
    </div>
  );
}

export default CreateMethodDialog;
